import { createIcon } from '@chakra-ui/react';

export const ArrowRightIcon = createIcon({
  displayName: 'ArrowRightIcon',
  path: (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        // width="16"
        // height="16"
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          d="M9.62012 3.95337L13.6668 8.00004L9.62012 12.0467"
          stroke="#6E6789"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2.33301 8H13.553"
          stroke="#6E6789"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  ),
});
